import {NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { MaterialModule } from './material.module';
import { NotificationModule } from './notification/notification.module';
import { LoadingButtonComponent, LoadingButtonCssMatStylerDirective,
   LoadingRaisedButtonCssMatStylerDirective } from './loading-button/button';
import { FileSizePipe } from './file-size.pipe';
import { MomentPipe } from './moment.pipe';
import { NumeralPipe } from './numeral.pipe';
import { PasswordStrengthComponent } from './password-strength/password-strength';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ValidatorTinDirective } from './validateTin.validator';
import { PaginatorComponent } from './paginator';
import { AppLoaderComponent } from './app-loader/app-loader.component';
import { ModalDialog } from './modal-dialog';
import { MessageBox, MessageBoxComponent } from './message-box/message-box';
import { PdpaPolicyComponent } from "./pdpa-policy/pdpa-policy.component";
import { PdpaAgreementComponent } from './pdpa-agreement/pdpa-agreement.component';
import { PdpaEkycComponent } from './pdpa-ekyc/pdpa-ekyc.component';
import { PdpaNdidComponent } from './pdpa-ndid/pdpa-ndid.component';
import { SafeHTMLPipe } from './safeHTML.pipe';
import { RegisterBarComponent } from './register-bar/register-bar.component';


export function createTranslateLoader(http: HttpClient) {
   return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
   imports: [
      CommonModule,
      HttpClientModule,
      MaterialModule,
      TranslateModule.forRoot({
         loader: {
            provide: TranslateLoader,
            useFactory: (createTranslateLoader),
            deps: [HttpClient]
         }
      })
   ],
   declarations: [
      AppLoaderComponent,
      LoadingButtonComponent,
      LoadingButtonCssMatStylerDirective,
      LoadingRaisedButtonCssMatStylerDirective,
      FileSizePipe,
      MomentPipe,
      NumeralPipe,
      SafeHTMLPipe,
      PasswordStrengthComponent,
      PaginatorComponent,
      ValidatorTinDirective,
      MessageBoxComponent,
      PdpaPolicyComponent,
      PdpaAgreementComponent,
      PdpaEkycComponent,
      PdpaNdidComponent,
      RegisterBarComponent,
   ],
   exports: [
      AppLoaderComponent,
      MaterialModule,
      NotificationModule,
      LoadingButtonComponent,
      LoadingButtonCssMatStylerDirective,
      LoadingRaisedButtonCssMatStylerDirective,
      FileSizePipe,
      MomentPipe,
      NumeralPipe,
      PasswordStrengthComponent,
      TranslateModule,
      PaginatorComponent,
      ValidatorTinDirective,
      PdpaPolicyComponent,
      RegisterBarComponent,
   ],
   providers: [
      ModalDialog,
      MessageBox,
   ]
})
export class SharedModule {}
